// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__cU-bM","infoBtn":"quickbooks_infoBtn__1sgVI","formBox":"quickbooks_formBox__X6JlT","formFooter":"quickbooks_formFooter__jZDsc"};